import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const NotFoundPage = () => (
  <section data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center px-5">
    <div className="text-center max-w-lg">
      <div className="overline mb-6">404 · Page Not Found</div>
      <h1 className="font-display text-ink text-6xl md:text-7xl leading-none tracking-[-0.02em]">Off the page.</h1>
      <p className="mt-6 text-ink-soft">The address you followed no longer exists in the publication. Return to the front page and pick up from there.</p>
      <Link to="/" className="mt-10 inline-flex items-center gap-3 px-8 py-4 border border-ink text-ink rounded-full hover:bg-ink hover:text-paper transition-colors text-sm font-medium" data-testid="notfound-home-link">
        Return to Front Page <ArrowRight size={14} />
      </Link>
    </div>
  </section>
);

export default NotFoundPage;
